import { Component, OnInit, ElementRef, AfterViewInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UniqueIdService } from 'app/shared/services/unique-id.service';
import { LibraryAsset } from 'app/library-assets/models/library-asset';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LibraryAssetResult } from 'app/library-assets/models/library-asset-result';
import { LibraryExerciseAnswer } from '../models/LibraryExerciseAnswer';

@Component({
  selector: 'dac-exercise',
  templateUrl: './exercise.component.html',
  styleUrls: ['./exercise.component.scss']
})
export class ExerciseComponent implements OnInit, AfterViewInit {

  @Input() exercise:LibraryAsset;
  @Input() result:LibraryAssetResult;
  @Output() onSubmit = new EventEmitter<LibraryAssetResult>();
  @Input("disabled") disabled:Boolean;
  @Input() hideHeaders:boolean;

  @ViewChild('journal') journal:ElementRef;
  
  private answerIds:string[];
  private boundClickHandler:any;

  public ExerciseContent:SafeHtml;

  constructor(private element:ElementRef, private idService:UniqueIdService, private domSanitizer:DomSanitizer) { 
    this.answerIds = [];
    this.hideHeaders = false;
    let clearText = function(evt:MouseEvent) {
      let element = evt.target as HTMLElement;
      element.innerText = "";
      evt.target.removeEventListener('focus', clearText);
    };
    this.boundClickHandler = clearText;
  }

  ngOnInit() {
    // we've sanitized this on the server, and we need to get the ids 
    if (this.exercise && this.exercise.content) {
      this.ExerciseContent = this.domSanitizer.bypassSecurityTrustHtml(this.exercise.content);
    }
  }

  ngOnDestroy() {
    if (!this.result) {
      let elements = this.element.nativeElement.querySelectorAll('.exercise-answer');
      for (var i = 0; i < elements.length; i++) {
        elements[i].removeEventListener('focus', this.boundClickHandler);
      }
    }
  }

  ngAfterViewInit() {
    if (!this.exercise) {
      return; // no exercise... nothing to do here.
    }
    if (!this.result) {
      this.setupExerciseClickHandlers();
    } else {
      this.populateExerciseAnswers(this.result.answers);
      this.populateExerciseJournal(this.result.journal);
    }
  }

  public hasJournal() {
    if (this.exercise.journal) {
      return true;
    }
    return false;
  }

  private populateExerciseAnswers(answers:LibraryExerciseAnswer[]) {
    if (!answers.length) {
      return;
    }
    answers.forEach(a => {
      let element = this.element.nativeElement.querySelector("#" + this.exercise.getAnswerIdPrefix() + a.id);
      if (element) {
        element.innerText = a.answer;
      }
    });
  }

  private populateExerciseJournal(journal:string) {
    if (this.journal && journal) {
      this.journal.nativeElement.innerText = journal;
    }
  }
  private setupExerciseClickHandlers() {
    let elements = this.element.nativeElement.querySelectorAll('.exercise-answer');
    for (var i = 0; i < elements.length; i++) {
      elements[i].contentEditable = true;
      elements[i].addEventListener('focus', this.boundClickHandler);
      if (elements[i].id) {
        let id = elements[i].id.replace(this.exercise.getAnswerIdPrefix(), "");
        this.answerIds.push(id);
      }
    }
  }
  public print() {
    if (window && window.print) {
      window.print();
    }
  }

  /**
   * Saves off the answers and journal and sends it to the caller.
   */
  public submit() {
    let answers = this.answerIds.map(i => {
      let element = this.element.nativeElement.querySelector('#' + this.exercise.getAnswerIdPrefix() + i);
      return {
        id: i
        ,answer: element ? element.innerText : null
      };
    });

    let journalEntry = null;
    if (this.journal) {
      journalEntry = this.journal.nativeElement.innerText;
    }

    let result = new LibraryAssetResult();
    result.asset = this.exercise;
    result.answers = answers;
    result.journal = journalEntry;
    this.onSubmit.next(result);
  }
}



// WEBPACK FOOTER //
// ./src/app/library-assets/exercise/exercise.component.ts